
<template>
  <v-dialog persistent v-model="accounts.modals.deleteAccount" width="450">
    <v-card>


      <v-toolbar dark  color="#4A76A8" flat  height="42">
        <v-toolbar-title  >  Удаление  аккаунта  </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="accounts.modals.deleteAccount = false">mdi-close</v-icon>
      </v-toolbar>



      <v-card-text scrollable>

        <div style=" min-height:60px;">
                <div style="float:left; min-width:60px;max-height:55px; overflow:hidden ">  <img :src="this.accounts.accGroups.deleteId.photo_50" style="border-radius:50%; " > </div>
                <div>  <a style="text-decoration:none" target="_blank"   :href="'https:vk.com/id'+this.accounts.accGroups.deleteId.id"  >  <span style="color:green"> {{this.accounts.accGroups.deleteId.first_name}} {{this.accounts.accGroups.deleteId.last_name}} </span></a></div>
        </div>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#4A76A8" small
          flat
          @click="accounts.modals.deleteAccount = false"
        >
          Отмена
        </v-btn>
        <v-btn
          :loading = "accounts.loader"
          color="red" small class="white--text"
          @click="deleteOk()"
        >
          Удалить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>

import axios from 'axios'

export default {

props:['accounts'],
  data () {
    return {

  }
},
methods:{
  deleteOk: function(){
    this.accounts.loader = true
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/accounts_delete.php', {
         method: 'POST',
         data: {
           id: this.accounts.accGroups.deleteId.id
         }
       }).then(response => {

     this.updateAccounts()

       })

},

updateAccounts: function(){
if(this.accounts.accGroups.list.length < 1)  {this.accounts.loader = true}
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/accounts_get.php', {
     contentType: 'JSONP',
     method: 'get',
     params: {
       grId: this.accounts.accGroups.selectedGr.gr_id,
     }
     }).then(response => {
 this.accounts.loader = false
 if(response.data ){
   this.accounts.accGroups.list = response.data
 } else {
   this.accounts.accGroups.list = []
 }
 this.accounts.loader = false
 this.accounts.modals.deleteAccount = false
 this.$store.dispatch('changeCounters')
     })

},



},
computed: {

},
created(){

},

}
</script>

<style   >

</style>
